import { render, staticRenderFns } from "./orabankrep.vue?vue&type=template&id=0f4541c2&scoped=true"
import script from "./orabankrep.vue?vue&type=script&lang=js"
export * from "./orabankrep.vue?vue&type=script&lang=js"
import style0 from "./orabankrep.vue?vue&type=style&index=0&id=0f4541c2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4541c2",
  null
  
)

export default component.exports